module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/design-tile-images/design-tile-09-157d750a9df71cc280ff9532fcd2d8cd.jpg";